import React, { useState } from "react";
import Modal from "react-modal";
import { Box, Button, Avatar, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { PiListDashesFill } from "react-icons/pi";
import { TfiClip } from "react-icons/tfi";
import Etiquetas from "../../Etiquetas";
import Members from "../../Members";
import { Span, Div, Flex } from "../../../style";
import SideMenuPadrao from "../SideMenuPadrao";
import { getAvatarUrl } from "../../../utils/getAvatarUrl";
import Checkbox from "@mui/material/Checkbox";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import Checklist from "../../Checklist";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ChecklistPadrao from "../ChecklistPadrao";

function CardModalPadrao({ modalIsOpen, closeModal }) {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const getBrightness = (hex) => {
    let r, g, b;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    } else {
      return null;
    }
    return (r * 299 + g * 587 + b * 114) / 1000;
  };

  const isDark = (hex) => {
    const brightness = getBrightness(hex);
    return brightness < 128;
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Detalhes do Card"
        className="card-modal"
        overlayClassName="card-modal-overlay"
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
      >
        <div
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          {/* Renderiza capa de cor */}

          <Flex>
            <div
              style={{
                backgroundColor: "#009373",
                width: "100%",
                height: "140px",
                position: "relative",
                borderRadius: "10px 10px 0px 0px",
              }}
              className="card-cover"
            ></div>
          </Flex>
          {/* Header sobre a capa se existir */}
          <Flex className={`details-header1 overlay-header`}>
            <div className="name-list">
              <p style={{ fontSize: "12px", margin: "0px" }}>Eu sou uma Tag</p>
            </div>
            <div className="buttons-header">
              <MoveToInboxIcon
                style={{ cursor: "pointer" }}
                title="Arquivar cartão"
              />
              <DeleteRoundedIcon className="delete-card" />
              <CloseIcon style={{ cursor: "pointer" }} onClick={closeModal} />
            </div>
          </Flex>
          <Flex
            style={{
              paddingBottom: "35px",
              paddingLeft: "35px",
              flex: 1,
              overflow: "hidden",
            }}
          >
            <Div className="first-column">
              <div className="sticky-card-header">
                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <Checkbox
                    {...label}
                    icon={<PanoramaFishEyeIcon />}
                    checkedIcon={<TaskAltIcon style={{ color: "green" }} />}
                    sx={{
                      padding: "8px 0px",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  />
                  <Div className="titulo-card-tour">
                    <h2>Eu sou o título do card</h2>
                  </Div>
                </div>
              </div>
              <br></br>
              <div className="scrollable-content">
                <div className="buttons-actions">
                  <button className="button-actions">
                    <AddRoundedIcon style={{ fontSize: "20px" }} /> Checklist
                  </button>
                  <button className="button-actions">
                    <ContentCopyRoundedIcon style={{ fontSize: "17px" }} />{" "}
                    Copiar
                  </button>
                  <button className="button-actions">
                    <AddRoundedIcon style={{ fontSize: "20px" }} /> Capa
                  </button>
                  <button className="button-actions">
                    <ShareRoundedIcon style={{ fontSize: "17px" }} />{" "}
                    Compartilhar
                  </button>
                </div>
                <Flex className="members-tags">
                  <div style={{ marginRight: "15px", marginLeft: "10px" }}>
                    <Span>Membros</Span>
                    <Flex
                      style={{
                        marginTop: "10px",
                        maxWidth: "205px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Avatar
                        className="comment-avatar"
                        src={getAvatarUrl("lesteboard")}
                        sx={{ width: 24, height: 24, ml: -1 }}
                        title="Lesteboard"
                      />

                      <div className="button-open-membro">
                        <IconButton>
                          <AddIcon style={{ color: "white", padding: "5px" }} />
                        </IconButton>
                      </div>
                    </Flex>
                  </div>
                  <div>
                    <Span>Etiquetas</Span>
                    <Flex style={{ maxWidth: "410px", flexWrap: "wrap" }}>
                      <div
                        style={{
                          backgroundColor: "#009373",
                          minWidth: "60px",
                          width: "fit-content",
                          height: "30px",
                          marginTop: "10px",
                          borderRadius: "5px",
                          color: isDark ? "white" : "black",
                          fontSize: 13,
                          fontWeight: 500,
                          padding: "3px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {"Aqui ficam as tags"}
                      </div>
                      <div className="button-open-etiqueta">
                        <IconButton>
                          <AddIcon style={{ color: "white", padding: "3px" }} />
                        </IconButton>
                      </div>
                    </Flex>
                  </div>
                </Flex>
                <div className="description-anexos">
                  <div>
                    <Flex
                      style={{
                        marginBottom: "20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Flex style={{ alignItems: "center" }}>
                        <PiListDashesFill style={{ fontSize: "25px" }} />
                        <Span style={{ fontSize: "15px" }}>Descrição</Span>
                      </Flex>

                      <div>
                        <Button
                          component="label"
                          htmlFor="file-upload"
                          className="description-edit"
                        >
                          Editar
                        </Button>
                        <input id="file-upload" style={{ display: "none" }} />
                      </div>
                    </Flex>
                    <div
                      style={{
                        marginLeft: "15px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {"Aqui você pode fazer uma melhor descrição do seu card"}
                    </div>
                  </div>
                  <br></br>

                  <div style={{ marginBottom: "15px" }}>
                    <Flex
                      style={{
                        marginBottom: "20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Flex style={{ alignItems: "center" }}>
                        <TfiClip style={{ fontSize: "25px" }} />
                        <Span style={{ fontSize: "15px" }}>Anexos</Span>
                      </Flex>

                      <div>
                        <Button
                          component="label"
                          htmlFor="file-upload"
                          className="description-edit"
                        >
                          Anexar
                        </Button>
                        <input id="file-upload" style={{ display: "none" }} />
                      </div>
                    </Flex>
                    <div
                      style={{
                        marginLeft: "15px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      {"Aqui ficam os anexos do seu card"}
                    </div>
                  </div>
                </div>
                <br></br>

                <ChecklistPadrao />
              </div>
            </Div>
            <Div className="second-column">
              <SideMenuPadrao />
            </Div>
          </Flex>
        </div>
        <Div style={{ width: "calc(100% - 600px)", display: "none" }}>
          <Typography variant="h6" style={{ marginTop: 20 }}>
            Etiquetas
          </Typography>
          <Box
            display="flex"
            marginBottom={2}
            flexDirection={"column"}
            gap={"5px"}
          >
            {["#FF5733", "#33FF57", "#3357FF", "#F333FF", "#FF33F3"].map(
              (color) => (
                <Button
                  style={{
                    backgroundColor: color,
                    minWidth: 40,
                    height: 40,
                    marginRight: 10,
                  }}
                />
              )
            )}
          </Box>
          <Box display="flex">
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: label,
                marginRight: 1,
              }}
            />
          </Box>
        </Div>
      </Modal>
    </>
  );
}

export default CardModalPadrao;
